import { render, staticRenderFns } from "./awardExport.vue?vue&type=template&id=6226695a"
import script from "./awardExport.vue?vue&type=script&lang=js"
export * from "./awardExport.vue?vue&type=script&lang=js"
import style0 from "./awardExport.vue?vue&type=style&index=0&id=6226695a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports